var text_field_default = {
  "root": "QNeZM",
  "text": "WWq-J",
  "input": "bjxID",
  "small": "cl0wm",
  "medium": "fUaPb",
  "large": "u9GJp",
  "webview": "I1--V",
  "endAdornment": "Jw4qa",
  "shown": "OMvzH",
  "value": "DjLo7",
  "spinner": "N6E-e",
  "spin": "_6s-Lm"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
